import firebase from 'firebase/compat/app';
import { Machine } from './types';

const getCollection = () => firebase.firestore().collection(`machines`);

export const fetchMachine = async (machineId: string): Promise<Machine | null> => {
  const doc = await getCollection().doc(machineId).get();
  if (!doc.exists) return null;
  return { id: doc.id, ...doc.data() } as Machine;
};

export const fetchMachines = async (orgId: string): Promise<Machine[]> => {
  const snapshot = await getCollection().where('orgId', '==', orgId).get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() } as Machine));
};

export const createMachine = async (machine: Omit<Machine, 'id'>): Promise<string> => {
  const docRef = await getCollection().add({
    ...machine,
    createTime: firebase.firestore.FieldValue.serverTimestamp(),
    updateTime: firebase.firestore.FieldValue.serverTimestamp(),
  });
  return docRef.id;
};

export const updateMachine = async (
  machineId: string,
  updates: Partial<Omit<Machine, 'id'>>
): Promise<void> => {
  await getCollection()
    .doc(machineId)
    .set(
      {
        ...updates,
        updateTime: firebase.firestore.FieldValue.serverTimestamp(),
      },
      { merge: true }
    );
};
